export const SET_MESSAGES = 'TOASTER_MOTDS_SET_MESSAGES'
export const ADD_MESSAGE = 'TOASTER_MOTDS_ADD_MESSGAE'
export const RESHOW_LATEST_MOTD = 'TOASTER_MOTDS_RESHOW_LATEST_MOTD'
export const MOTDS_CHANGED = 'TOASTER_MOTDS_MOTDS_CHANGED'

export const MOTD_OUTDATED = 'TOASTER_MOTDS_MOTD_OUTDATED'
export const MOTD_FETCHING = 'TOASTER_MOTDS_MOTD_FETCHING'
export const MOTD_FETCHED = 'TOASTER_MOTDS_MOTD_FETCHED'
export const MOTD_FETCH_FAILED = 'TOASTER_MOTDS_MOTD_FETCH_FAILED'



// WEBPACK FOOTER //
// ./src/features/Toaster/data/motds/constants.js